import script from "./ShopsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopsTable.vue?vue&type=script&setup=true&lang=ts"

import "./ShopsTable.vue?vue&type=style&index=0&id=8ac2e4e0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ac2e4e0"]])

export default __exports__